import log from '@atlassian/jira-common-util-logging/src/log.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { createResource } from '@atlassian/react-resource-router';
import { RESOURCE_TYPE_GIC_OPTIN_STATUS } from './constants.tsx';

export type GicOptInStatusResourceData = {
	gicOptInStatus: {
		isEnabled: boolean;
		expiryTime?: number;
	} | null;
};

export const gicOptInStatusResources = createResource<GicOptInStatusResourceData>({
	type: RESOURCE_TYPE_GIC_OPTIN_STATUS,
	getKey: () => 'gic_optin_status',
	getData: async (): Promise<GicOptInStatusResourceData> => {
		let gicOptInStatus = null;

		try {
			gicOptInStatus = await performGetRequest(
				'/rest/greenhopper/1.0/profile/labs-panel/modern-gic-visibility',
			);
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
		} catch (e: any) {
			if (e.statusCode !== 404) {
				log.safeErrorWithoutCustomerData(
					'spa.router.resources.navigation.gicVisibility',
					'getGICVisibility',
					e,
				);
			}
		}
		return {
			gicOptInStatus: gicOptInStatus ?? { isEnabled: false },
		};
	},
	maxAge: Number.MAX_VALUE,
});

// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
export { RESOURCE_TYPE_GIC_OPTIN_STATUS } from './constants';
